export default "__VITE_ASSET__CnPz0WXJ__"